module.exports = __webpack_public_path__ + "static/media/about.2e2c2580.jpg";